.tabButton {
  margin: 0;
  border: 0;
  background: transparent;
  height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:focus {
    outline: 0;
  }

  & .tabButtonLabel {
    font-size: 0.875rem;
    font-weight: 400;
    color: var(--gray);
  }
}

.tabButtonSkinny {
  height: 3rem;
}

.tabListSkinny {
  margin-bottom: 30px !important;
}

.tab {
  background-color: var(--silver);
  transition-duration: 0.2s;
  transition-property: color, background-color;

  &.selected {
    background-color: var(--white);
  }

  &.selected .tabButton {
    box-shadow: inset 0 3px 0 #0098d0;
  }

  & .tabButtonIcon {
    color: var(--darkSilver);
  }

  &.selected .tabButtonLabel,
  &.selected .tabButtonIcon {
    color: var(--blue);
  }
}
